export const isProduction = () => {
  return process.env.GATSBY_APP_ENV === 'production';
};

export const isDevelopment = () => {
  return process.env.GATSBY_APP_ENV === 'development';
};
